module.exports = __webpack_public_path__ + "static/img/finance.091b022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finance.png
// module id = WJ7X
// module chunks = 1